export const config = {
    apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:9000/api/v1' : 'https://mcalc.bitsbydenis.de/api/v1',
}
